import { LinkDropdown } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import { upperFirst } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import PatientInfoDropdownButton from '../PatientInfoDropdownButton';
import LanguageMenuContainer from './LanguageMenuContainer';

const sx = StyleSheet.create({
  menuStyles: {
    left: 0,
    right: 'initial',
  },
});

const LanguageDropdown = ({ patient }) => {
  const [optimisticLanguage, setOptimisticLanguage] = useState(null);

  useEffect(() => {
    setOptimisticLanguage(null);
  }, [patient?.language]);

  const displayLanguage = useMemo(
    () => optimisticLanguage ?? patient?.language,
    [optimisticLanguage, patient?.language],
  );

  return patient ? (
    <LinkDropdown
      buttonRenderer={
        <PatientInfoDropdownButton
          icon="speechBubble"
          id="e2e-languageDropdown"
          text={upperFirst(displayLanguage)}
          title="Edit language"
        />
      }
      menuRenderer={
        <LanguageMenuContainer patient={patient} onLanguageUpdated={setOptimisticLanguage} />
      }
      menuStyles={sx.menuStyles}
    />
  ) : null;
};

LanguageDropdown.propTypes = {
  patient: PropTypes.object,
};

export default LanguageDropdown;
